import React, { useState, useEffect } from 'react';
import GridAdd from '../../../../components/GridAdd/GridAdd';
import { Color } from '../../../../const/Const';
import { API } from '../../../../API/API';
import NewEducation from './New/NewEducation';
import NewCert from './New/NewCert';
import { hideLoadScreen, showLoadScreen } from '../../../../components/LoadScreen/LoadScreen';
import { useParams } from 'react-router-dom';

const Education = (props) => {

    const params = useParams();
    const [empid, setEmpId] = useState(-1);
    const [onOpenEducation, setOnOpenEducation] = useState(false);
    const [dataEducation, setDataEducation] = useState([]);
    const [entryidEducation, setEntryidEducation] = useState();

    const [onOpenCert, setOnOpenCert] = useState(false);
    const [dataCert, setDataCert] = useState([]);
    const [entryidCert, setEntryidCert] = useState();

    useEffect(() => {
        let tEmpId = -1;
        if (params.empid) {
            tEmpId = params.empid;
        }
        setEmpId(tEmpId);
    }, [params]);

    const getExistsData = async () => {

        let tDataEducation = [];
        let tDataCert = [];
        if (empid > 0) {
            showLoadScreen();
            await API.get('/api/humanresource/employee/get_empeducation_list?empid=' + empid).then(response => {
                if (response.status == 200 && response.data?.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tDataEducation = response.data.retdata;
                    }
                }
            });

            await API.get('/api/humanresource/employee/get_empcertificate_list?empid=' + empid).then(response => {
                if (response.status == 200 && response.data?.rettype == 0) {
                    if (response.data?.retdata?.length > 0) {
                        tDataCert = response.data.retdata;
                    }
                }
            });

            hideLoadScreen();
        }

        setEntryidEducation();
        setEntryidCert();
        setDataEducation(tDataEducation);
        setDataCert(tDataCert);
    }

    useEffect(() => {
        getExistsData();
    }, [empid]);

    const onDismissEducation = () => {
        setEntryidEducation(-1);
        setOnOpenEducation(false);
    }

    const onEditEducation = (p_entryid) => {
        setEntryidEducation(p_entryid);
        setOnOpenEducation(true);
    }

    const afterSaveEducation = async (p_close) => {
        if (p_close) {
            setOnOpenEducation(false);
        }
        await getExistsData();
    }


    const onDismissCert = () => {
        setEntryidCert(-1);
        setOnOpenCert(false);
    }

    const onEditCert = (p_entryid) => {
        setEntryidCert(p_entryid);
        setOnOpenCert(true);
    }

    const afterSaveCert = async (p_close) => {
        if (p_close) {
            setOnOpenCert(false);
        }
        await getExistsData();
    }

    return (
        <div style={{ padding: 8 }}>
            <div>
                <GridAdd
                    title={`Боловсрол ${dataEducation.length > 4 ? `(${dataEducation.length})` : ""}`}
                    description="суурь боловсрол, дипломын дээд боловсрол, бакалавр, магистрын зэргийг оруулна"
                    onNew={() => { setOnOpenEducation(true); }}
                    data={dataEducation}
                    columns={[{
                        name: 'Сургууль',
                        fieldName: 'universityname',
                        onRender: (item) => {
                            return (
                                <div
                                    onClick={() => onEditEducation(item.entryid)}
                                    style={{ color: Color.blue, cursor: 'pointer' }}
                                >
                                    {item.universityname}
                                </div>
                            );
                        }
                    }, {
                        name: 'Улс',
                        fieldName: 'countryname',
                    }, {
                        name: 'Аймаг, хот',
                        fieldName: 'divisionname',
                    }, {
                        name: 'Элссэн огноо',
                        fieldName: 'fromdate',
                    }, {
                        name: 'Төгссөн огноо',
                        fieldName: 'todate',
                    }, {
                        name: 'Мэргэжлийн төрөл',
                        fieldName: 'professiontypename'
                    }, {
                        name: 'Мэргэжил',
                        fieldName: 'professionname'
                    }, {
                        name: 'Боловсролын төрөл',
                        fieldName: 'educationtypename'
                    }, {
                        name: 'Боловсролын түвшин',
                        fieldName: 'educationlevelname'
                    }, {
                        name: 'Голч дүн',
                        fieldName: 'gpa'
                    }, {
                        name: 'Голч дүн /хувиар/',
                        fieldName: 'gpapercent'
                    }]}
                />
                <NewEducation
                    entryid={entryidEducation}
                    empid={empid}
                    onOpen={onOpenEducation}
                    onDismiss={onDismissEducation}
                    afterSave={afterSaveEducation} />
            </div>
            <div style={{ marginTop: 24 }}>
                <GridAdd
                    title={`Гэрчилгээ ${dataCert.length > 4 ? `(${dataCert.length})` : ""}`}
                    description=""
                    onNew={() => { setOnOpenCert(true); }}
                    data={dataCert}
                    columns={[{
                        name: 'Гэрчилгээ',
                        fieldName: 'certificatename',
                        onRender: (item) => {
                            return (
                                <div
                                    onClick={() => onEditCert(item.entryid)}
                                    style={{ color: Color.blue, cursor: 'pointer' }}
                                >
                                    {item.certificatename}
                                </div>
                            );
                        }
                    }, {
                        name: 'Гэрчилгээний дугаар',
                        fieldName: 'certificateno'
                    }, {
                        name: 'Эхлэх огноо',
                        fieldName: 'certificatedate'
                    }, {
                        name: 'Дуусах огноо',
                        fieldName: 'expirydate'
                    }]}
                />
                <NewCert
                    entryid={entryidCert}
                    empid={empid}
                    onOpen={onOpenCert}
                    onDismiss={onDismissCert}
                    afterSave={afterSaveCert} />
            </div>
        </div>
    );
}

export default Education;